import {useCallback, useMemo, useState} from 'react';
import {Autocomplete, ListBoxOptionType} from '@flixbus/honeycomb-react';
import {BusPartnersFilterProps} from './BusPartnersFilter.types';

const BusPartnersFilter: React.FC<BusPartnersFilterProps> = ({
  countries,
  onSelected
}) => {
  const allOptions: ListBoxOptionType[] = useMemo(
    () =>
      countries.map(country => ({
        title: country.name,
        value: country.id
      })),
    [countries]
  );
  const [filteredOptions, setFilteredOptions] = useState<ListBoxOptionType[]>(
    []
  );

  const renderOption = useCallback(
    (option: ListBoxOptionType) => option.title,
    []
  );

  const handleDebounce = useCallback(
    async (inputValue: string) => {
      const searchedText = inputValue.toLowerCase();

      if (!searchedText) {
        setFilteredOptions([]);
        return [];
      }

      const filteredCountries = allOptions.filter(option =>
        option.title.toLowerCase().startsWith(searchedText)
      );
      setFilteredOptions(filteredCountries);

      return filteredCountries;
    },
    [allOptions]
  );

  const handleChange = useCallback(
    (selected: ListBoxOptionType[]) => {
      const countryIds = selected.map(s => s.value as string);
      onSelected(countryIds);
    },
    [onSelected]
  );

  return (
    <Autocomplete
      multiple
      comboboxProps={{
        label: 'Countries',
        resetProps: {
          label: 'Clear',
          onClick: () => onSelected([])
        },
        'aria-label': 'Countries'
      }}
      options={filteredOptions}
      listBoxProps={{
        optionsToDisplay: 5,
        optionProps: option => ({
          renderOption: () => renderOption(option)
        })
      }}
      onDebounce={handleDebounce}
      onChange={handleChange}
    />
  );
};

export default BusPartnersFilter;
